import React from 'react';
import cn from 'bem-cn';

import { Icon } from '../Icon';

import { ScoreBadgeProps } from './ScoreBadge.types';

import './ScoreBadge.scss';

const b = cn('score-badge');

export const ScoreBadge: React.FC<ScoreBadgeProps> = ({
    size,
    score,
    isLoading = false,
    showPrefix = false,
    className,
}) => {
    if (isLoading) {
        return <div className={b({ size }).mix('skeleton', className)} />;
    }
    const displayScore = Number((score ?? 0).toFixed(2));

    return (
        <div className={b({ size }).mix(className)}>
            {showPrefix && <span className={b('prefix')}>ИИ:</span>}
            {/* округляем до двух знаков после запятой и отбрасываем нули на конце */}
            {/* вместо нуля рисуем прочерк */}
            {displayScore || '–'}
            <Icon name="logo" size={16} fillColor="var(--graphite-color)" />
        </div>
    );
};
